const initialState = {
	'paymentTypes': [],
}

const filterData = function (state = initialState, action) {
	switch (action.type) {
		case "SET_CASHBOX":
			return { ...state, ...action.payload };
		default:
			return state;
	}
};

export default filterData